import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  CUSTOM_ORDER_HISTORY_OVERVIEW,
  CustomOrderHistoryState,
  customOrderHistoryFeatureKey,
  CUSTOM_ORDER_HISTORY_CANCEL_ORDER,
  CUSTOM_ORDER_HISTORY,
  CUSTOM_ORDER_HISTORY_CANCEL_ORDER_ENTRY,
  CUSTOM_ORDER_HISTORY_UPDATE_ORDER_ENTRIES,
  CUSTOM_ORDER_HISTORY_OVERVIEW_FILTERS
} from './custom-order-history.reducer';

export const selectCustomOrderHistoryState = createFeatureSelector<CustomOrderHistoryState>(
  customOrderHistoryFeatureKey
);

//******************************************************

export const selectOverview = createSelector(
  selectCustomOrderHistoryState,
  (state: CustomOrderHistoryState) =>
    state[CUSTOM_ORDER_HISTORY_OVERVIEW].overview
);

export const loadingOverview = createSelector(
  selectCustomOrderHistoryState,
  (state: CustomOrderHistoryState) =>
    state[CUSTOM_ORDER_HISTORY_OVERVIEW].isLoading
);

export const errorOverview = createSelector(
  selectCustomOrderHistoryState,
  (state: CustomOrderHistoryState) =>
    state[CUSTOM_ORDER_HISTORY_OVERVIEW].error
);

//******************************************************

export const selectOverviewFilters = createSelector(
  selectCustomOrderHistoryState,
  (state: CustomOrderHistoryState) =>
      state[CUSTOM_ORDER_HISTORY_OVERVIEW_FILTERS].customOrderHistoryRequest
);

export const selectBackToOverview = createSelector(
  selectCustomOrderHistoryState,
  (state: CustomOrderHistoryState) =>
      state[CUSTOM_ORDER_HISTORY_OVERVIEW_FILTERS].backToOverview
);
//******************************************************

export const selectOrder = createSelector(
  selectCustomOrderHistoryState,
  (state: CustomOrderHistoryState) =>
    state[CUSTOM_ORDER_HISTORY].order
);

export const loadingOrder = createSelector(
  selectCustomOrderHistoryState,
  (state: CustomOrderHistoryState) =>
    state[CUSTOM_ORDER_HISTORY].isLoading
);

export const errorOrder = createSelector(
  selectCustomOrderHistoryState,
  (state: CustomOrderHistoryState) =>
    state[CUSTOM_ORDER_HISTORY].error
);

//*******************************************************

export const successCancelOrder = createSelector(
  selectCustomOrderHistoryState,
  (state: CustomOrderHistoryState) =>
    state[CUSTOM_ORDER_HISTORY_CANCEL_ORDER].success
);

export const errorCancelOrder = createSelector(
  selectCustomOrderHistoryState,
  (state: CustomOrderHistoryState) =>
    state[CUSTOM_ORDER_HISTORY_CANCEL_ORDER].error
);

//*******************************************************

export const successCancelOrderEntry = createSelector(
  selectCustomOrderHistoryState,
  (state: CustomOrderHistoryState) =>
    state[CUSTOM_ORDER_HISTORY_CANCEL_ORDER_ENTRY].success
);

export const errorCancelOrderEntry = createSelector(
  selectCustomOrderHistoryState,
  (state: CustomOrderHistoryState) =>
    state[CUSTOM_ORDER_HISTORY_CANCEL_ORDER_ENTRY].error
);

//*******************************************************

export const successUpdateOrderEntries = createSelector(
  selectCustomOrderHistoryState,
  (state: CustomOrderHistoryState) =>
    state[CUSTOM_ORDER_HISTORY_UPDATE_ORDER_ENTRIES].success
);

export const errorUpdateOrderEntries = createSelector(
  selectCustomOrderHistoryState,
  (state: CustomOrderHistoryState) =>
    state[CUSTOM_ORDER_HISTORY_UPDATE_ORDER_ENTRIES].error
);
